import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  collection,
  getDocs,
  addDoc,
  Timestamp,
  doc,
  getDoc,
} from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import { getAuth } from 'firebase/auth';
import { useTranslation } from 'react-i18next';
import PinModal from '../PinModal';
import './CustomerClinicPage.css'; // ✅ Custom styles

import CustomerClinicReview from './CustomerClinicReview'; // ✅ correct one

const CustomerClinicPage = () => {
  const { token } = useParams();
  const { t } = useTranslation();
  const [clinics, setClinics] = useState([]);
  const [selectedClinic, setSelectedClinic] = useState(null);
  const [showPinModal, setShowPinModal] = useState(false);
  const [confirmationMsg, setConfirmationMsg] = useState('');

  useEffect(() => {
    const fetchClinics = async () => {
      const snapshot = await getDocs(collection(db, 'clinics'));
      const result = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setClinics(result.filter(c => c.is_active));
    };
    fetchClinics();
  }, []);

  const handleConfirmVisit = async (pin) => {
    if (!selectedClinic) return false;

    const clinicDoc = await getDoc(doc(db, 'clinics', selectedClinic.id));
    const clinicData = clinicDoc.data();
    if (clinicData?.admin_pin !== pin) return false;

    const auth = getAuth();
    const currentUser = auth.currentUser;

    try {
      await addDoc(collection(db, 'clinic_visits'), {
        customer_token: token,
        clinic_id: selectedClinic.id,
        clinic_name: selectedClinic.name,
        visited_at: Timestamp.now(),
        confirmed_by_uid: currentUser?.uid || 'unknown',
        confirmed_by_email: currentUser?.email || 'unknown',
      });
      setConfirmationMsg(t('customerClinic.visitConfirmed'));
      setShowPinModal(false);
      return true;
    } catch (error) {
      console.error('Error logging visit:', error);
      return false;
    }
  };

  return (
    <div className="customer-clinic-container">
      <h2 className="page-title">{t('customerClinic.title')}</h2>
      <div className="card">
        <label className="field-label">{t('customerClinic.selectClinic')}</label>
        <select
          className="clinic-select"
          onChange={(e) => {
            const clinic = clinics.find(c => c.id === e.target.value);
            setSelectedClinic(clinic);
            setConfirmationMsg('');
          }}
        >
          <option value="">{t('customerClinic.chooseOption')}</option>
          {clinics.map(clinic => (
            <option key={clinic.id} value={clinic.id}>
              {clinic.name} ({clinic.location})
            </option>
          ))}
        </select>

        {selectedClinic && (
          <div className="centered">
            <button
              onClick={() => setShowPinModal(true)}
              className="confirm-btn"
            >
              {t('customerClinic.confirmDiscount')}
            </button>
          </div>
        )}

        {confirmationMsg && (
          <div className="confirmation-box">
            ✅ {confirmationMsg}
            <div className="content-section">
              {selectedClinic?.barcode_url ? (
                <img
                  src={selectedClinic.barcode_url}
                  alt="Discount Barcode"
                  className="barcode-image"
                />
              ) : selectedClinic?.discount_code ? (
                <div className="discount-code-box">
                  {selectedClinic.discount_code}
                </div>
              ) : (
                <p className="no-discount">{t('customerClinic.noDiscountAvailable')}</p>
              )}
            </div>
          </div>
        )}
      </div>

      {selectedClinic && confirmationMsg && (
  <div className="mt-6">
    <CustomerClinicReview
      customerToken={token}
      clinicId={selectedClinic.id}
    />
  </div>
)}

      {showPinModal && (
        <PinModal
          isOpen={showPinModal}
          onClose={() => setShowPinModal(false)}
          onSubmit={handleConfirmVisit}
        />
      )}
    </div>
  );
};

export default CustomerClinicPage;
